module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Login","email":"E-mail","password":"Password","loginButton":"Login","forgotPassword":"Forgot password?","badLoginOrPassword":"Bad email or password"}}')
  delete Component.options._Ctor
}
